import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Fallecimiento } from '../models/fallecimiento';
import { filter, Subject, tap } from 'rxjs';
import { CuotaEntrada } from '../models/cuotasEntrada';
import { ApiService } from './api.service';
import { CuotaRecurrente } from '../models/cuotaRecurrente';
import { PrestacionRecurrente } from '../models/prestacionRecurrente';
import { PrestacionRentaIT } from '../models/prestacionRentaIT';
import { Associate } from '../models/associate.model';


@Injectable({
  providedIn: 'root'
})
export class CommonService {
  nombre: string = ''

  public previousUrl: string | null = null;
  public currentUrl: string | null = null;

  constructor(private router: Router,
    private apiService: ApiService
  ) { 
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: any) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });

  }

  isValidSpanishDNI(dni: string): boolean {
    const dniRegex = /^\d{8}[A-Z]$/; // 8 digits followed by a letter
    if (!dniRegex.test(dni)) {
      return false;
    }

    const numberPart = parseInt(dni.slice(0, 8), 10);
    const letterPart = dni.charAt(8);
    const validLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const expectedLetter = validLetters.charAt(numberPart % 23);

    return letterPart === expectedLetter;
  }


  espacioComponente(){
    // Aquí puedes acceder al elemento padre y manipular su segundo hijo
    const contenedor = document.getElementById('componente')

    // Aplicando estilos al segundo hijo
    if (contenedor && contenedor.children.length >= 2) {
      const segundoHijo = contenedor.children[1] as HTMLElement; // Type assertion
      segundoHijo.style.flex = '1';
      segundoHijo.style.display='flex';
      segundoHijo.style.flexDirection='column';

      segundoHijo.classList.add('componenteRenderizado');
      // Puedes aplicar cualquier estilo aquí según tus necesidades
    }
  }

  public expandedElement: Fallecimiento | null = null;

  public expandedElementFe: Associate | null = null;

  public expandedElementCuotas: CuotaEntrada | null = null;

  public expandedElementCuotaRec: CuotaRecurrente | null = null;

  public expandedElementPrestacionRec: PrestacionRecurrente | null = null;

  public expandedElementPrestacionRentaIT: PrestacionRentaIT | null = null;

  //AVISAR AL COMPONENTE DE ALERTA ICONO

  private alertaActualizada = new Subject<void>();
  alertaActualizada$ = this.alertaActualizada.asObservable();


  saveAlerta(data: any) {
    return this.apiService.saveAlerta(data).pipe(
      tap(() => this.alertaActualizada.next()) // notifica después de guardar
    );
  }
  
  deleteAlerta(id: number) {
    return this.apiService.deleteAlerta(id).pipe(
      tap(() => this.alertaActualizada.next()) // notifica después de borrar
    );
  }

  notificarActualizacion() {
  this.alertaActualizada.next();
  }

}
